import QuickDecorate from '../../shared/quick-decorate'
import { Alert, Container } from './style'

type Props = {
    className?: string
}

const UGELayersEditorEmpty = ({ className }: Props) => {
    return (
        <Alert
            className={className}
            description="First add captions or stickers to your creation, then return here for layer tooling."
            stickerUrl="https://s3.amazonaws.com/giphygifs/media/ViHbdDMcIOeLeblrbq/200w.gif"
            title="You don't have any layers, yet!"
        >
            <Container>
                <QuickDecorate />
            </Container>
        </Alert>
    )
}

export default UGELayersEditorEmpty
